import { message } from "antd";

import { AppStrings } from "../../utils/constants/AppStrings";

import type { ReportingSummaryRow } from "./reportingSummaryTypes";
import { buildReportingSummaryCsv } from "./reportingSummaryUtils";

export const REPORTING_SUMMARY_DOWNLOAD_FILENAME =
  "sportsbook-reporting-summary.csv";

/**
 * Programmatic CSV download in the browser (same pattern as CasinoProvidersReports).
 */
export function triggerClientCsvFileDownload(
  csv: string,
  filename: string = REPORTING_SUMMARY_DOWNLOAD_FILENAME,
): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}

/** Exports the given reporting summary rows as a CSV download (typically the current table page). */
export function downloadReportingSummaryTable(
  rows: ReportingSummaryRow[] | null | undefined,
): void {
  if (!rows || rows.length === 0) {
    message.warning(AppStrings.REPORTING_SUMMARY_EXPORT_PENDING);
    return;
  }
  try {
    const csv = buildReportingSummaryCsv(rows);
    triggerClientCsvFileDownload(csv);
  } catch (err) {
    // eslint-disable-next-line no-console -- surfaced to operators; user sees message.error
    console.error("[ReportingSummaryExport]", err);
    message.error(AppStrings.REPORTING_SUMMARY_EXPORT_ERROR);
  }
}
